const styles = {
  control: (styles: any, state: any) => ({
    ...styles,
    borderColor: state.isFocused ? '#85b8ff' : '#c8c9d0',
    borderThickness: 1,
    boxShadow: 'none',
    borderRadius: 8,
  }),
  menu: (styles: any) => ({
    ...styles,
    border: '1px solid #E4E4E7',
    boxShadow: '0px 4px 12px 1px #0000001A',
    color: '#00000099',
  }),
  menuList: (styles: any) => ({
    ...styles,
    maxHeight: 450,
    paddingTop: 0,
    paddingBottom: 0,
  }),
  group: (styles: any) => ({
    ...styles,
    paddingBottom: 0,
  }),
  option: (styles: any) => ({
    ...styles,
    padding: '4px 12px',
    fontSize: 14,
    lineHeight: '28px',
    borderBottom: '1px solid #e4e4e7',
  }),
};

export default styles;
